import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

export const compactFirstScroll = !IS_MOBILE_BROWSER && isFeature('compact-first-scroll');
